/**
 * PURATHANA WAREHOUSE ROUTER
 * Browser-side only. No backend required.
 *
 * Flow:
 *   1. Customer enters pincode
 *   2. Resolve pincode → lat/lng (static map first, then free API)
 *   3. Haversine distance to each of 4 Bangalore warehouses
 *   4. Write nearest warehouse to Shopify cart attributes via /cart/update.js
 *   5. Shiprocket Shopify app reads the order attribute at fulfillment time
 */

// ─── 4 WAREHOUSE LOCATIONS ──────────────────────────────────────────────────
// shiprocketName = exact "Location Name" in Shiprocket panel
// (Settings → Pickup Addresses → column "Location Name")

const PURATHANA_WAREHOUSES = [
  {
    id:             'primary',
    shiprocketName: 'PURATHANA',
    area:           'Kumaraswamy Layout',
    pincode:        '560078',
    lat:            12.8897,
    lng:            77.5692,
    address:        '1st Cross Road, near 210U bus stop, Vittal Nagar, Kumaraswamy Layout 2nd Stage, Kumaraswamy Layout, Bengaluru, Karnataka, India, 560078',
    spoc:           'SANDYA',
    phone:          '9535643034',
  },
  {
    id:             'tejas',
    shiprocketName: 'TEJAS',
    area:           'Bikasipura / Kanakapura Road',
    pincode:        '560062',
    lat:            12.8728,
    lng:            77.5472,
    address:        'SHREE SAI PALACE 2ND CROSS DODDAKALASANDRA KANAKAPURA MAIN ROAD, Bikasipura, Bengaluru, Karnataka - 560062',
    spoc:           'Tejas',
    phone:          '9901032512',
  },
  {
    id:             'anupama',
    shiprocketName: 'Anupama',
    area:           'Anjanapura Township',
    pincode:        '560108',
    lat:            12.8412,
    lng:            77.5793,
    address:        'Anand Somu Pristine Block-A, Anjanapura Township, Bengaluru, Karnataka - 560108',
    spoc:           'ANUPAMA',
    phone:          '9980630222',
  },
  {
    id:             'anuradha',
    shiprocketName: 'Anuradha',
    area:           'JP Nagar',
    pincode:        '560078',
    lat:            12.9082,
    lng:            77.5868,
    address:        '10/3, J. P. Nagar, Bengaluru, Karnataka - 560078',
    spoc:           'ANURADHA',
    phone:          '9886316330',
  },
];

// ─── STATIC BANGALORE PINCODE → LAT/LNG MAP ────────────────────────────────
// Covers ~70 most common Bangalore pincodes. No API call needed for these.
const BLR_PINCODE_MAP = {
  '560001': [12.9716, 77.5946], '560002': [12.9794, 77.5917],
  '560003': [12.9766, 77.5713], '560004': [12.9857, 77.5517],
  '560010': [12.9719, 77.6412], '560011': [12.9499, 77.6393],
  '560012': [12.9538, 77.6154], '560016': [12.9344, 77.6269],
  '560017': [12.9607, 77.5550], '560018': [12.9780, 77.5298],
  '560019': [12.9349, 77.6910], '560020': [12.9459, 77.5618],
  '560021': [12.9592, 77.5330], '560022': [12.9416, 77.5500],
  '560023': [12.9299, 77.5516], '560024': [12.9220, 77.5454],
  '560025': [12.9099, 77.5666], '560026': [12.9183, 77.6272],
  '560027': [12.9079, 77.5971], '560028': [12.9317, 77.5829],
  '560029': [12.9185, 77.6094], '560030': [12.9350, 77.6110],
  '560034': [12.9196, 77.6486], '560035': [12.9483, 77.7076],
  '560037': [12.9831, 77.6367], '560038': [12.9543, 77.7005],
  '560040': [13.0197, 77.5985], '560041': [13.0358, 77.5970],
  '560043': [12.9698, 77.7480], '560045': [12.9347, 77.6937],
  '560047': [12.9698, 77.7480], '560048': [13.0125, 77.6497],
  '560049': [13.0591, 77.6487], '560050': [13.0454, 77.6266],
  '560051': [13.0684, 77.6001], '560052': [13.0354, 77.5626],
  '560053': [13.0285, 77.5428], '560054': [12.9861, 77.5102],
  '560055': [13.0071, 77.5056], '560056': [12.9701, 77.6050],
  '560058': [12.9956, 77.5736], '560059': [12.9910, 77.5599],
  '560060': [12.9543, 77.4884], '560061': [12.9230, 77.4876],
  '560062': [12.8728, 77.5472], '560064': [12.9004, 77.6134],
  '560065': [12.8468, 77.6643], '560068': [12.9108, 77.6474],
  '560069': [12.9770, 77.6826], '560070': [12.9955, 77.6924],
  '560072': [12.9282, 77.6714], '560076': [12.8750, 77.6400],
  '560078': [12.8960, 77.5750], '560082': [12.9235, 77.6955],
  '560085': [13.0106, 77.7013], '560087': [12.9940, 77.6644],
  '560091': [12.9108, 77.4952], '560094': [12.9480, 77.5097],
  '560095': [13.0050, 77.5890], '560097': [12.9683, 77.5024],
  '560098': [12.9483, 77.4727], '560100': [12.8987, 77.6650],
  '560102': [12.8412, 77.5600], '560103': [12.8637, 77.6193],
  '560105': [12.8550, 77.5200], '560107': [12.8750, 77.4800],
  '560108': [12.8412, 77.5793], '560109': [12.8609, 77.6359],
  '560111': [13.0591, 77.7150], '560114': [12.9768, 77.7097],
};

// South Indian state pincodes start with these digits → good ETA estimate
const SOUTH_INDIA_PREFIXES = ['56', '57', '58', '59', '60', '61', '62', '63', '64', '67', '68', '69'];

// ─── HAVERSINE DISTANCE (km) ────────────────────────────────────────────────
function haversineKm(lat1, lng1, lat2, lng2) {
  const R    = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a    = Math.sin(dLat / 2) ** 2
             + Math.cos(lat1 * Math.PI / 180)
             * Math.cos(lat2 * Math.PI / 180)
             * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

// ─── PINCODE → COORDINATES ─────────────────────────────────────────────────
async function pincodeToCoords(pin) {
  // 1. Static Bangalore map (instant)
  if (BLR_PINCODE_MAP[pin]) {
    return { lat: BLR_PINCODE_MAP[pin][0], lng: BLR_PINCODE_MAP[pin][1] };
  }
  // 2. Free postalpincode.in API (no key, works for all India)
  try {
    const res  = await fetch('https://api.postalpincode.in/pincode/' + pin);
    const data = await res.json();
    if (data[0]?.Status === 'Success' && data[0].PostOffice?.length > 0) {
      const po  = data[0].PostOffice[0];
      const lat = parseFloat(po.Latitude  || po.latitude  || '');
      const lng = parseFloat(po.Longitude || po.longitude || '');
      if (!isNaN(lat) && lat !== 0) return { lat, lng, state: po.State };
    }
  } catch (_) {}
  return null;
}

// ─── ETA LABEL ─────────────────────────────────────────────────────────────
function getEta(pin) {
  if (pin.startsWith('56') || pin.startsWith('57') || pin.startsWith('58')) {
    // Karnataka
    if (pin.startsWith('560') || pin.startsWith('561') || pin.startsWith('562') || pin.startsWith('563')) {
      return { min: 1, max: 2, label: 'Bangalore Priority Dispatch' };
    }
    return { min: 1, max: 3, label: 'Karnataka Express Dispatch' };
  }
  const isSouth = SOUTH_INDIA_PREFIXES.some(p => pin.startsWith(p));
  if (isSouth) return { min: 2, max: 3, label: 'South India Express Courier' };
  return { min: 3, max: 5, label: 'Pan-India Express Delivery' };
}

// ─── WRITE TO SHOPIFY CART ATTRIBUTES ──────────────────────────────────────
// This is the key step — the attribute flows into the Shopify order,
// and Shiprocket reads "Pickup Location" from the order attributes
// to know which warehouse to dispatch from.
async function setCartPickupAttribute(warehouse, distanceKm) {
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Pickup Location': warehouse.shiprocketName,
          'Dispatch Warehouse': warehouse.shiprocketName,
          'Warehouse SPOC': `${warehouse.spoc} (${warehouse.phone})`,
          'Estimated Distance KM': String(distanceKm),
        }
      })
    });
  } catch (e) {
    console.warn('[WarehouseRouter] Could not update cart attributes:', e.message);
  }
}

// ─── MAIN PUBLIC API ────────────────────────────────────────────────────────
window.PurathanaRouter = {

  /**
   * resolve(pincode)
   * Returns { warehouse, distanceKm, eta, allDistances }
   * Also writes nearest warehouse to Shopify cart attributes.
   */
  async resolve(pincode) {
    const pin = String(pincode).replace(/\D/g, '');
    if (pin.length !== 6) throw new Error('Enter a valid 6-digit pincode.');

    const coords = await pincodeToCoords(pin);
    if (!coords) throw new Error('Could not locate pincode ' + pin + '. Please try again.');

    const ranked = PURATHANA_WAREHOUSES
      .map(wh => ({
        warehouse:  wh,
        distanceKm: Math.round(haversineKm(coords.lat, coords.lng, wh.lat, wh.lng) * 10) / 10,
      }))
      .sort((a, b) => a.distanceKm - b.distanceKm);

    const nearest = ranked[0];
    const eta     = getEta(pin);

    // Write to cart — happens silently in background
    setCartPickupAttribute(nearest.warehouse, nearest.distanceKm);

    // Cache for checkout to read
    try {
      sessionStorage.setItem('purathana_pickup', JSON.stringify({
        pin,
        shiprocketName: nearest.warehouse.shiprocketName,
        warehouseId:    nearest.warehouse.id,
        distanceKm:     nearest.distanceKm,
        eta,
        ts: Date.now(),
      }));
    } catch (_) {}

    return { warehouse: nearest.warehouse, distanceKm: nearest.distanceKm, eta, allDistances: ranked };
  },

  getCached() {
    try {
      const d = JSON.parse(sessionStorage.getItem('purathana_pickup') || 'null');
      if (!d || Date.now() - d.ts > 3_600_000) return null;
      return d;
    } catch (_) { return null; }
  },
};
